import { createNamespacedHelpers } from 'vuex'
const { mapState: activityMapState } = createNamespacedHelpers('activity')

export default {
  computed: {
    ...activityMapState([
      'activity'
    ]),
  },
}
